import AppRoutePath from "../../../../router/AppRoutePath";

export const paymentType = [
  // { label: "Installment", value: "installment" },
  { label: "Balloon Payment", value: "balloon_payment" },
];

export const tenorType = [
  { label: "Reguler", value: "reguler" },
  { label: "Non Regular", value: "non_reguler" },
];

export const changeInputRevaluation = [
  { label: "Ya", value: true },
  { label: "Tidak", value: false },
];

export const pawnType = [
  { label: "Reguler", value: "reguler" },
  { label: "Jemput Gadai", value: "pick_up" },
];

export const dataBreadcrumb = [
  { label: "Promo", route: AppRoutePath.CAMPAIGN },
  { label: "Pinjaman / Tambah Promo Offer Pinjaman", route: null },
];
